import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

interface Props {
  width: number;
  height: number;
  stroke: string;
}

const NextArrowIcon = (props: Props) => {
  const { width, height, stroke } = props;
  return (
    <SVGUniqueID>
      <svg
        width={width}
        height={height}
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M3.83203 7.99967H13.1654M13.1654 7.99967L8.4987 3.33301M13.1654 7.99967L8.4987 12.6663"
          stroke={stroke}
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SVGUniqueID>
  );
};

NextArrowIcon.defaultProps = {
  width: 17,
  height: 16,
  stroke: '#334155'
};

export { NextArrowIcon };
